"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    CTAtitle1: "Нужна консультация по выбору  изделий для нанесения?",
    CTAtitle2: "Подберем оптимальный способ печати под ваши задачи",
    CTAtitle3: "Остались вопросы?",
};
